import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  loading: false,
  data: [],
  error: "",
};

const deliveryListSlice = createSlice({
  name: "deliveryList",
  initialState,
  reducers: {
    termExamDeliveryListRequest(state, action) {
      state.loading = true;
    },
    termExamDeliveryListSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
  },
});

export const { termExamDeliveryListRequest, termExamDeliveryListSuccess } =
  deliveryListSlice.actions;

export default deliveryListSlice.reducer;
